
<template>
  <div>
       <div
  v-if="showOffersPage"
  class="responsive-grid offers-page-wrapper"
  :class="verticalOrientationCheck"
>
  <div
    page-id="one-to-one-offers"
    page-num="1"
    index="0"
    style="width: 100%; min-height: 1px;"
  >
    <OffersPage />
  </div>
    </div>
    <div v-else class="product-container" :mode="displayMode">
    <div
     class="product-grid"
	  :flyer-orientation="flyerOrientation"
		:class="{
			update: zIndex,
			update2: !zIndex,
			'no-gap': noGapAttr,
			'disable-popup': isDisablePopup,
			scrollable: filteredProducts.length > 10,
			'few-items': fewItems
		}"

      :root-scroll-container="rootScrollContainer"
    >
      <div
        v-for="(product, cardKey) in filteredProducts"
        :key="cardKey"
        class="product-card"
        tabindex="0"

        @click="onClick(product)"
      >
        <div class="content">
          <div class="product-image">
			<img
				v-if="hasImage(product)"
				:src="getImage(product)"
				alt=""
				loading="lazy"
				@error="e => e.target.src = '/images/noimage.svg'"
			/>
			<div v-else class="no-image"></div>
			</div>

         <div
			class="price-row"
			v-if="product.pricing && product.pricing.currentPrice && product.pricing.currentPrice.value != null"
			>
			<span class="product-price" :class="fontSizeClass">
				${{ product.pricing.currentPrice.value }}
			</span>

			<span
				class="product-reg-price"
				:class="fontSizeClass"
				v-if="
				product.pricing.originalPrice &&
				product.pricing.originalPrice.value != null &&
				product.pricing.originalPrice.value !== product.pricing.currentPrice.value
				"
			>
				${{ product.pricing.originalPrice.value }}
			</span>
			</div>

          <p
			class="savings"
			:class="fontSizeClass"
			v-if="
				product.pricing &&
				product.pricing.originalPrice &&
				product.pricing.currentPrice &&
				product.pricing.saveStory &&
				product.pricing.saveStory.label != null &&
				!isNaN(product.pricing.originalPrice.value - product.pricing.currentPrice.value)
			"
			>
			{{ product.pricing.saveStory.label }}
      <!-- //they added the differation in live api  -->
			<!-- (${{ (product.pricing.originalPrice.value - product.pricing.currentPrice.value).toFixed(2) }}) -->
			</p>

          <!-- <p class="product-name" :class="fontSizeClass">{{ product.name }}</p> -->
          <p class="product-desc" :class="fontSizeClass">{{ productDesc(product) }}</p>
          <div class="bottom-info">
            <div
              v-if="
                product.rating &&
                product.rating.averageRating &&
                Number(product.rating.numberOfReviews) > 0
              "
              class="rating"
            >
              <span class="stars">
                <span
                  v-for="n in 5"
                  :key="n"
                  class="star"
                  :class="{ filled: n <= filledStars(product) }"
                >
                  ★
                </span>
              </span>
              <span class="rating-text">
                {{ product.rating.averageRating }}
                ({{ product.rating.numberOfReviews }})
              </span>
            </div>
            <div
              v-if="product.inventory"
              class="inventory"
              :class="[{ out: !isInStock(product) }, fontSizeClass]"
            >
              {{ inventoryText(product) }}
            </div>
            <p v-if="product.defaultSku" class="product-number" :class="fontSizeClass">
              #{{ product.defaultSku }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
import { mapGetters, mapState, mapActions } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import {PRODUCT_REGION_CLICK_VALID} from "@/components/block/BlockEvents";
import OffersPage from "@/features/offers/OffersPage.vue";


export default {
	name: "SearchResultTiledView",
	mixins: [blockElementMixin],
	components: { OffersPage },
	props: [
     "flyerPages",
    "rootScrollContainer",
	"isGridView",
	"showOffersPage"
  ],
	
	data() {
		
		return {
			products: [
			],
			 zIndex: false,
			finelineNMs: [],
			lastcategory: [],
			cardKey:0,
			gridSize: 'grid-default',
			LayoutDirections: {
				HORIZONTAL: 0,
				VERTICAL: 1
			},
			saveLabel: 'Save',
		
	}},
	
	computed: {
		
		...mapGetters('ctUser', ['canViewTriangleRewards', 'isSignedIn', 'offerViewMode', 'hasOffers', 'isLoggedIntoCT', 'hasTriangleID']),
		...mapGetters(['content', 'language', 'storeId']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('landingPage', ['currentFlyer']),
		...mapState(['currentPageNumber']),
		...mapState('search', ['pricing','loading']),
		...mapGetters(['TiledView']),

fewItems() {
	  console.log('fewItems count:', this.filteredProducts.length);

  return this.filteredProducts.length > 0 && this.filteredProducts.length < 5;
},
		filteredProducts() {
			if (!this.products || !Array.isArray(this.products)) {
			return [];
			}
					const seen = new Set();
					return this.products

				.filter(p => {
					if (!p.defaultSku || p.defaultSku === "") return false;
					if (seen.has(p.defaultSku)) return false;
					seen.add(p.defaultSku);
					return true;
				})// remove empty/duplicate SKU
				.sort((a, b) => {
					const priceA = isNaN(a.numericPrice) ? Infinity : a.numericPrice;
					const priceB = isNaN(b.numericPrice) ? Infinity : b.numericPrice;
					return priceA - priceB;
					});
			
		},

    	isVerticalOnDesktop() {
			return this.displayMode === 'desktop' && this.flyerOrientation === 'vertical';
		},
		
		isPreviewFlyer() {
			return this.isLoggedIntoCT && this.hasTriangleID && this.offerViewMode === 'preview';
		},
		 isDisablePopup() {
        let flyerCategory = this.currentFlyer?.flyerCategory
	      return this.features?.otherPublications?.disablePopup && (flyerCategory?.includes('Other Publication - Responsive')
	       || flyerCategory?.includes('Specialty Book'));

		},
		noGapAttr(){
		return this.flyerPages.some(page=> page.noGapAfterPage) 
		},
		currentGridStyle: function () {
			const styles = {
				0: {
				gridTemplateColumns: `repeat(${this.flyerPages.length},max-content)`
				},
				1: {
				gridTemplateRows: `repeat(${this.flyerPages.length},max-content)`
				}
			};
			return styles[this.currentLayoutDirection];
			},

		currentLayoutDirection(){
      		return this.flyerOrientation == 'vertical'? this.LayoutDirections.VERTICAL : this.LayoutDirections.HORIZONTAL;
   		 },
		fontSizeClass() {
		 const count = this.filteredProducts?.length || 0;
		if (count < 5) return 'font-few';       // fewer items → smaller font
		if (count <= 10) return 'font-normal';  // medium count
		return 'font-small';
		},
		verticalOrientationCheck() {
			return {
				'dVertical': this.flyerOrientation === 'vertical' && (this.displayMode === 'desktop' || this.displayMode === 'tablet'),
				'vertical': this.flyerOrientation === 'vertical' && this.displayMode === 'mobile'
			}
		},
	},
	
	watch: { 		  //Every time flyerPages is set or changed, check if we're in Grid View and have at least one page.
					//  If so, run fetchProducts()
		flyerPages: {

				handler(newVal) {

				if (this.isGridView && newVal && newVal.length) {
					this.fetchProducts();
				}
				},

    		immediate: true
		},

		

	},
	
	methods: {
		...mapActions('events', ['triggerEvent']),
		hasImage(product) {
			return (
			product &&
			Array.isArray(product.images) &&
			product.images[0]
			);
		},

		getImage(product) {
			return product.images[0]?.url;
		},
		filledStars(product) {
    		return Math.floor(Number(product.rating.averageRating) || 0);
 			 },
			 isInStock(product) {
    		return Number(product.inventory.quantity) > 0;
  		},

		inventoryText(product) {
			const qty = Number(product.inventory.quantity);

			if (qty > 0) {
				return `${qty} ${this.content.inStock}`;
			}
			return this.content.outOfStock;
		},
		fetchProducts() {

			if (!Array.isArray(this.flyerPages)) {
				this.products = Object.freeze([]);
				return;
			}

			this.products = Object.freeze(
				this.flyerPages

				.map(product => ({
					...product,
					// Normalize CTC API fields for ITEM_POP (productRegionClickValid):
					// CTC New Api sends "skus" instead of "sku" → __self.sku
					sku: product.sku ?? product.skus,
					// CTC New Api sends "code" instead of "groupIds" → __self.product.groupIds
					product: {
						...product.product,
						groupIds: product.product?.groupIds ?? product.code
					},
					numericPrice: parseFloat(product?.Pricing?.originalPrice?.value ?? NaN) // numeric for filtering/sorting
				}))
			);
			},

		productDesc(product) {
			const desc = product.description;
			if (!desc) return "---"; // handle empty/null safely

			const firstSentence = desc.split('.')[0];
			return firstSentence.trim() + (desc.includes('.') ? '.' : '');
			},
		onClick(product) {
		
		this.triggerEvent({  event: PRODUCT_REGION_CLICK_VALID,
                  data: {...product, language: this.language,
							storeId: this.storeId, currentFlyer: this.currentFlyer,
						currentPageNumber: this.currentPageNumber}})
	
		},
		

	},
}
</script>
<style lang="scss">
.product-container {
  max-width: none;
  height: auto;
  overflow: hidden; //new
  //overflow: visible !important;
  transform-origin: top left;
  background-color: #fff;
  position: relative;
  top: 0;
  display: flex;
  gap: 20px;
  transition: 0.2s transform;

  .product-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 10px;
    justify-content: flex-start;
    align-content: flex-start;
    overflow-x: hidden;
    width: calc((140px * 7) + (4px * 6));

    &.noscroll {
      max-height: none;
      overflow-y: visible;
      justify-content: center;
    }

    .product-card {
      flex: 0 0 150px;
      border: 1px solid #f7f7f7;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
      padding: 8px;
      background: white;
      position: relative;
      cursor: pointer;
      display: flex;
      flex-direction: column;

      .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex: 1;

        .product-image {
          height: 100px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            max-height: 100px;
            max-width: 100%;
          }

          .no-image {
            width: 100%;
            height: 100px;
            background: url("/images/noimage.svg") center center / contain no-repeat;
          }
        }

        .price-row {
          display: flex;
          align-items: baseline;
          gap: 4px;
          margin-top: 5px;
          margin-left: 1px;

          .product-price {
            font-family: "CTEastmanCompressed", "Arial Narrow", sans-serif;
            letter-spacing: -0.01em;
            color: #e21111;
            text-shadow: none;

           
            &.font-small { font-size: 14px; }
          }

          .product-reg-price {
            font-family: "CTEastmanCompressed", "Arial Narrow", sans-serif;
            letter-spacing: -0.01em;
            color: #8b8e92;
            text-decoration: line-through;
            &.font-few { font-size: 9px !important; }
            &.font-normal { font-size: 9px; }
            &.font-small { font-size: 11px; }
          }
        }

        .savings {
         color: #8b8e92;
          font-size: 11px;
          font-family: Lato, sans-serif;
          margin-top: 2px;
          padding-top: 5px;

          &.font-normal, &.font-small { font-size: 9px; }
        }

        .product-desc {
          line-height: normal;
           font-size: 8px;
          margin: 5px 0 2px 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .bottom-info {
          margin-top: auto;
          width: 100%;
        }

        .product-number {
          color: #8b8e92;
          padding-top: 5px;

          &.font-small { font-size: 8px; font-weight: 200; }
          &.font-normal { font-size: 8px; font-weight: 200; }
          &.font-few { font-size: 8px; font-weight: 200; }

         
        }
      }
    }
  }
.product-container[mode='desktop'] {
  .product-grid.few-items {
    max-width: 340px;
    margin: 0 auto;

    .product-card {
      flex: 0 0 80px;
      min-height: 72px;
      height: auto;
      max-height: none;
      padding: 4px;
      overflow: visible;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .content {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        overflow: visible;
      }

      .product-image {
        height: 20px;
        flex-shrink: 0;

        img {
          max-height: 20px;
        }

        .no-image {
          height: 20px;
        }
      }

      .price-row {
        margin-top: 1px;
      }

      .product-price {
        font-size: 3px !important;
        text-shadow: none !important;
      }

      .product-desc {
        font-size: 3px !important;
        line-height: 1.15 !important;
        margin: 1px 0 !important;
        width: 100%;
        box-sizing: border-box;
        white-space: normal !important;
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
        line-clamp: 2 !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        min-height: 7px;
      }

      .bottom-info {
        margin-top: auto;
        width: 100%;
      }
    }
  }
}
}

.product-grid[flyer-orientation='vertical'] {
  margin: 0 auto;
}

.product-container[mode='mobile'] {
  max-width: 100vw;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;

  .product-grid {
    width: min(100%, 100dvw); 
    max-width: 100%;
    min-width: 320px; 
    margin: 0 auto;
    padding: 0 8px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 8px;
    overflow: visible;

    .product-card {
      flex: 0 0 calc(50% - 12px);
      max-width: calc(50% - 12px);
      min-width: 145px;
      box-sizing: border-box;
      padding: 8px 4px;

      .product-desc {
        font-size: 0.8em;
        font-family: Lato, sans-serif;
        line-height: 1.2;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }

      .product-number {
        font-size: 0.8em;
        line-height: 1.2;
      }

      .price-row {
        .product-price { font-size: 1em; }
        .product-reg-price { font-size: 0.9em; }
      }

      .star { font-size: 10px; }
    }
  }
}

.product-container[mode='tablet'] {
  display: flex;
  max-width: none;
  width: auto;

  .product-grid[flyer-orientation='vertical'] {
    max-width: 650px;
    width: 100%;
    margin: 0 auto;
    padding: 5px 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 8px;

    &.scrollable {
      max-height: none;
      overflow-y: visible;
    }
  }

  .product-card {
    flex: 0 0 130px;
  }

  .product-grid.few-items {
    max-width: 260px;
    margin: 0 auto;

    .product-card {
      flex: 0 0 60px;
      height: 45px;
      max-height: 45px;
      padding: 3px;
      overflow: hidden;
      box-sizing: border-box;

      .product-image {
        height: 20px;
        flex-shrink: 0;
        img { max-height: 20px; }
        .no-image { height: 20px; }
      }

      .content { overflow: hidden !important; min-height: 0; max-height: 100%; }
      .price-row { margin-top: 1px !important; }
      .product-price { font-size: 3px !important; text-shadow: none !important; }
      .product-reg-price { font-size: 3px !important; text-decoration: none !important; background: linear-gradient(#8b8e92, #8b8e92) no-repeat 0 50% / 100% 0.3px; }
      .savings { font-size: 3px !important; padding-top: 0 !important; margin-top: 0 !important; margin-bottom: 2px !important; }
      .product-desc { font-size: 3px !important; line-height: 1.1 !important; margin: 1px 0 !important; width: 100%; padding-left: 1px; box-sizing: border-box; display: -webkit-box !important; -webkit-box-orient: vertical !important; -webkit-line-clamp: 1 !important; line-clamp: 1 !important; overflow: hidden !important; max-height: 4px !important; }
      .product-number { font-size: 3px !important; padding-top: 0 !important; }
      .star { font-size: 3px !important; }
      .rating { font-size: 3px !important; margin-top: 0 !important; }
      .rating-text { font-size: 3px !important; }
      .inventory { font-size: 3px !important; margin-top: 0 !important; }
      .bottom-info { margin-top: 0 !important; }
    }
  }
}

.rating {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  font-family: Lato, sans-serif;
  font-size: 8px;
  font-weight: 600;
  margin-top: 4px;
}

.stars {
  color: #f5a623;
  margin-right: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}

.star {
  font-size: 14px;

  &.filled { color: #f5a623; }
  &:not(.filled) { color: #ddd; }
}
.offers-page-wrapper {
  overflow: visible !important;
  padding-bottom: 60px;
  .offers-body,
  .carousel,
   .VueCarousel.vertical,
  .VueCarousel.dVertical  {
    overflow: visible !important;
  }

  .VueCarousel,
  .VueCarousel.vertical,
  .VueCarousel.dVertical {
    width: 420px !important;
  }

  .VueCarousel-wrapper {
    overflow: hidden !important;
  }

 
  .container.dVertical {
    grid-template-columns: repeat(3, 140px) !important;
    column-gap: normal !important;
    row-gap: 1em !important;
    margin: 0 !important;
  }
.container.vertical{
  grid-template-columns: repeat(2,208px);
  column-gap: 0.8em;
}


  .card.vertical,
  .card.dVertical {
    height: 98% !important;
  }

  .custom_controls,
  .custom_controls.dVertical {
    display: flex !important;
    justify-content: center;
    align-items: center;
    gap: 24px;
    width: 100%;
    position: relative;
    z-index: 50;
    margin-top: 14px;
    padding-bottom: 35px;
    bottom: unset;
  }

  .custom_controls.vertical {
    margin-top: 14px;
    padding-bottom: 35px;
    bottom: unset ;
  }

  .pagination-dots {
    display: flex !important;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
 &.dVertical {
    .nav-controls {
      height: 28px !important;
      padding: 4px !important;
    }

    .navBtn {
      height: 20px !important;
      width: 20px !important;
    }

    .pagination-dots span {
      height: 8px !important;
      width: 8px !important;
      margin-top: 4px !important;
    }
  }
  

  .offers-body {
    display: flex;
    justify-content: center;
  }

  .offers-page-header {
    display: flex;
    justify-content: center;

    .offer-page-container {
      max-width: 420px;
      width: 100%;
    }
  }
}
.rating-text {
  color: #333;
  font-weight: 500;
}

.inventory {
  font-size: 8px;
  font-weight: 600;
  margin-top: 4px;
  color: #d0021b;
  font-family: Lato, sans-serif;

  &.out { color: #999; }
  &.font-few { font-size: 7px !important; margin-top: 0 !important; margin-bottom: 2px !important; }
  &.font-normal { font-size: 7px; }
  &.font-small { font-size: 8px; }
}
</style>
    
